export default {
	'add-journal': 'Add journal',
	post: 'post',
	unpost: 'unpost',
	posted: 'Posted',
	unposted: 'Unposted',
	'preview-receiving': 'Preview receiving',
	'preview-delivery': 'Preview delivery',
	'the-journal': 'The journal?',
	'preview-order-results': 'Preview order results',
	'preview-production-order': 'Preview production order',
}